import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { NgxPageScrollModule } from 'ngx-page-scroll';

import { AppRoutingModule } from './app-routing.module';
import { IconsModule } from './shared/icons/icons.module';

import { ComponentsModule } from './components/components.module';
import { ExamplesModule } from './examples/examples.module';

import { AppComponent } from './app.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { OverviewComponent } from './examples/overview/overview.component';


@NgModule({
    declarations: [
        AppComponent,
        NavbarComponent,
        OverviewComponent
    ],
    imports: [
        BrowserAnimationsModule,
        NgbModule.forRoot(),
        IconsModule,
        FormsModule,
        NgxPageScrollCoreModule.forRoot({
            _logLevel: 1,
            duration: 1000,
            scrollOffset: 64,
            interruptible: false
        }),
        NgxPageScrollModule,
        RouterModule,
        AppRoutingModule,
        ComponentsModule
        // ExamplesModule
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }
